<h1 style="font-size: 60px">Twisted</h1>
<p class="normal-font"><b>How to play</b></p>
<p class="normal-font">Follow the on screen instructions to complete the quest.</p>
<p class="normal-font">
  You’ll meet characters who want to tell you their stories, <em><b>watch their films closely and look out for hidden
  magical objects, each character will have one, they are the passwords to unlock the next level.</b></em>
  Follow the map on your screen, it will lead you to within 5 meters of your next token.
  Then, put your phone down and start looking around you for the token. When you find it, scan the next QR code to keep
  playing.
  (Tokens will never be buried, but they won’t always be on the floor, so keep your eyes peeled!)
</p>
<p class="normal-font">PLAY SAFELY & RESPONSIBLY
  Adhere to social distancing guidance in your area.
  Do not touch or remove tokens.
  Children should always play with a responsible adult.
  Films are rated PG.
  Be aware of your surroundings and always use pedestrian crossings when crossing roads.
  Play in daylight
</p>
<iframe style="width: 90%; margin-top:5px; margin-bottom: 5px;" height="315" src="https://www.youtube.com/embed/UfZB4HNpLk8?controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
<!-- Where are you right now?  -->
<select class="burton-input" [(ngModel)]="location">
  <option value="-1" selected="true" disabled="true">Where are you playing?</option>
  <option value="0">Warrington</option>
<!--  <option value="1">Stanley Park</option>-->
</select>

<button (click)="process()" class="burton-button mt-1">Start Adventure</button>

<!-- Mailing list popup -->
<div class="popup" [@quickFadeIn]="mailingListPopupState" [class.popup-open]="mailingListPopupState === 'open'"
     [class.popup-closed]="mailingListPopupState === 'closed'">
  <div class="popup-header">
    <h1>Before you start...</h1>
    <p style="font-size: 20px">Sign up to our mailing list so you dont miss anything...</p>
  </div>
  <div class="popup-body">

    <input class="burton-input" style="color: black;border-color: black;padding-left: 10px;" placeholder="Email address"
           [(ngModel)]="email"/>
    <button class="burton-button mt-1 mb-1" (click)="signup()" style="background-color: black; color: white;">Sign Up
    </button>
    <br/>
    <a (click)="noThanks()" class="mt-1">No Thanks</a>
  </div>

</div>


<div class="popup" [@quickFadeIn]="needsLocationPermissions" [class.popup-open]="needsLocationPermissions === 'open'"
     [class.popup-closed]="needsLocationPermissions === 'closed'">
  <div class="popup-header">
    <h1>We need your location to play this game..</h1>
    <p style="font-size: 20px">Enable location services for your browser through your phone settings before playing.</p>
    <p *ngIf="checkFailed" style="color: #ff0d3a;">Could not access location - please try again.</p>
  </div>
  <div class="popup-body">
    <button class="burton-button mt-1 mb-1" (click)="checkLocation(true)" style="background-color: black; color: white;">Check permissions
    </button>
    <br/>
  </div>

</div>
